import { render, staticRenderFns } from "./pcoreword1.vue?vue&type=template&id=8502e4be&scoped=true&"
import script from "./pcoreword1.vue?vue&type=script&lang=js&"
export * from "./pcoreword1.vue?vue&type=script&lang=js&"
import style0 from "./pcoreword1.vue?vue&type=style&index=0&id=8502e4be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8502e4be",
  null
  
)

export default component.exports